import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseThrowError } from '@/_utils/services';
import type { MissionByManager } from '../types';

export const GET_MISSION_BY_ID = 'GET_MISSION_BY_ID';

type GetMissionByIdParams = {
  missionId: string;
};

const getMissionById = ({ missionId }: GetMissionByIdParams) =>
  apiClient
    .get<MissionByManager>(`/missions/${missionId}/by-manager`)
    .then(response => response.data)
    .catch(handleResponseThrowError());

type GetMissionByIdData = Awaited<ReturnType<typeof getMissionById>>;

export const useGetMissionById = (
  params: GetMissionByIdParams,
  options: Omit<
    UseQueryOptions<
      GetMissionByIdData,
      unknown,
      GetMissionByIdData,
      (string | GetMissionByIdParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) =>
  useQuery({
    queryKey: [GET_MISSION_BY_ID, params],
    queryFn: () => getMissionById(params),
    enabled: !!params.missionId,
    ...options,
  });
